<i [ngClass]="iconClass"></i>
